import { Account } from '@/entities/Account'
import { AccountRequests } from '@/services/account.requests'
const accountService = new AccountRequests()

import Vue from 'vue'

const state = {
  read: null,
  edited: null
}
const getters = {}

const actions = {
  get ({ state }, { id }) {
    return new Promise((resolve, reject) => {
      accountService.get(id).then(async (account) => {
        state.read = account
        resolve(account)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  save ({ state, commit }, { id, profileId, active }) {
    return new Promise((resolve, reject) => {
      var read = state.read ? state.read.account : new Account()
      if (id) { commit('setField', { field: 'id', value: id }) }
      commit('setField', { field: 'profileId', value: profileId })
      commit('setField', { field: 'active', value: active })
      accountService.save(read.serialize(state.edited)).then((id) => {
        commit('resetEdited')
        resolve(id)
      }).catch((error) => {
        reject(error)
      })
    })
  }
}

const mutations = {
  setRead (state, account) {
    state.read = account
  },
  setField (state, { field, value }) {
    if (!state.edited) {
      state.edited = {}
      if (state.read && state.read.id) {
        Vue.set(state.edited, 'id', state.read.id)
      }
    }
    Vue.set(state.edited, field, value)
  },
  resetEdited (state) {
    state.edited = {}
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
